import { Link } from "react-router-dom";
import { BedDouble, Bath, Ruler, MapPin } from "lucide-react";
import { formatPrice, formatNumber, PURPOSE_LABELS } from "@/lib/format";
import { FALLBACK_IMG } from "@/lib/images";

export default function PropertyCard({ property, large = false }) {
  const p = property;
  const img = p.images?.[0] || FALLBACK_IMG;
  return (
    <Link
      to={`/properties/${p.id}`}
      className="card-lux group block overflow-hidden rounded-2xl"
      data-testid={`property-card-${p.id}`}
    >
      <div className={`relative overflow-hidden ${large ? "h-72 md:h-96" : "h-60"}`}>
        <img
          src={img}
          alt={p.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        <span
          className={`absolute top-4 start-4 rounded-full px-4 py-1.5 text-xs font-heading font-bold ${
            p.purpose === "sale" ? "bg-forest text-ivory" : "bg-gold text-forest"
          }`}
          data-testid={`property-purpose-${p.id}`}
        >
          {PURPOSE_LABELS[p.purpose] || p.purpose}
        </span>
        <span className="absolute bottom-4 start-4 rounded-full bg-white/90 backdrop-blur px-4 py-1.5 text-sm font-heading font-bold text-forest" data-testid={`property-price-${p.id}`}>
          {formatPrice(p.price, p.purpose)}
        </span>
      </div>
      <div className="p-5 space-y-3">
        <h3 className="font-heading font-bold text-lg text-forest leading-snug line-clamp-1">{p.title}</h3>
        <p className="flex items-center gap-1.5 text-sm text-muted-foreground">
          <MapPin className="h-4 w-4 text-gold-dark" aria-hidden="true" />
          {p.city}{p.district ? ` — ${p.district}` : ""}
        </p>
        <div className="flex items-center gap-5 pt-2 border-t border-forest/10 text-sm text-charcoal/80">
          {p.bedrooms > 0 && (
            <span className="flex items-center gap-1.5" data-testid={`property-beds-${p.id}`}>
              <BedDouble className="h-4 w-4 text-gold-dark" aria-hidden="true" />
              {formatNumber(p.bedrooms)} غرف
            </span>
          )}
          {p.bathrooms > 0 && (
            <span className="flex items-center gap-1.5">
              <Bath className="h-4 w-4 text-gold-dark" aria-hidden="true" />
              {formatNumber(p.bathrooms)}
            </span>
          )}
          <span className="flex items-center gap-1.5" data-testid={`property-area-${p.id}`}>
            <Ruler className="h-4 w-4 text-gold-dark" aria-hidden="true" />
            {formatNumber(p.area)} م²
          </span>
        </div>
      </div>
    </Link>
  );
}
